import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { OccConfig, OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReturnstremserviceService {
  private imageUploadSubject = new BehaviorSubject<any>(null);
  public imageUpload$ = this.imageUploadSubject.asObservable();
  private imagefailureSubject = new BehaviorSubject<any>(null);
  public imageUploadfailure$ = this.imagefailureSubject.asObservable();
  constructor(private http: HttpClient,private occConfig: OccConfig, private ngZone: NgZone, private occ: OccEndpointsService,) {}
  public eventSources: { [token: string]: EventSource } = {};
   public keepAliveIntervals: { [token: string]: any } = {};
  public connect(qrcode:any) {
    if (this.eventSources[qrcode]) {
      return;
    }
    const sseUrl = this.occ.buildUrl(`/qrscanner/stream/${qrcode}`);


    this.ngZone.runOutsideAngular(() => {
        const eventSource = new EventSource(sseUrl)
        this.eventSources[qrcode] = eventSource;
    
        this.keepAliveIntervals[qrcode] = setInterval(() => {
          // You can trigger a lightweight request here if needed
        }, 3000);

        eventSource.addEventListener('images_uploaded', (event: MessageEvent) => { 
          this.ngZone.run(() => { 
            //const data = JSON.parse(event.data); 
            //console.log('Images uploaded event:', data); 
            this.imageUploadSubject.next(qrcode);
             // Optionally close connection after success
             this.disconnect(qrcode); }); });   

              
             eventSource.addEventListener('failure', (event: MessageEvent) => { 
          this.ngZone.run(() => { 
            //const data = JSON.parse(event.data); 
            //console.log('Images uploaded event:', data); 
            this.imagefailureSubject.next(qrcode);
             // Optionally close connection after success
             this.disconnect(qrcode); }); }); 

             eventSource.addEventListener('timeout', (event: MessageEvent) => { 
              this.ngZone.run(() => { 
                //const data = JSON.parse(event.data); 
                //console.log('Images uploaded event:', data); 
                this.imagefailureSubject.next(qrcode);
                 // Optionally close connection after success
                 this.disconnect(qrcode); }); }); 

            /*    eventSource.onmessage = (response) => { this.ngZone.run(() => { console.log('Default message:', response.data);
                this.imageUploadSubject.next(qrcode);
                console.log("success")
                eventSource.close(); 
                clearInterval(this.keepAliveIntervals[qrcode]);
                 delete this.eventSources[qrcode];
                delete this.keepAliveIntervals[qrcode];
               });
             };  */

       /*  this.eventSources[qrcode].onmessage = (response) => {
          this.ngZone.run(() => {
        console.log(response)
        this.imageUploadSubject.next("hi");
        if (this.eventSources[qrcode]) { 
          this.eventSources[qrcode].close();
           // close the SSE connection
            clearInterval(this.keepAliveIntervals[qrcode]);
             // stop its keepalive 
             delete this.eventSources[qrcode];
              // remove from dictionary 
              delete this.keepAliveIntervals[qrcode]; 
              // clean up interval reference 
              }
          });
        }; */
        eventSource.onerror = (error) => { 
          this.ngZone.run(() => { 
            this.imagefailureSubject.next(qrcode);
            this.disconnect(qrcode);
          });
         };
    });
  }

   public disconnect(qrcode:string): void {
    this.eventSources[qrcode].close(); 
    delete this.eventSources[qrcode]; 
    clearInterval(this.keepAliveIntervals[qrcode]); 
    delete this.keepAliveIntervals[qrcode];
  } 
}
